<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/105zr4R/tc-custom/9780226650913.jpg?1738725234514" alt="This image is the cover for the book Higher and Colder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Higher and Colder
      </h1>
      <p class="bookDescription body article font2">
        <p>During the long twentieth century, explorers went in unprecedented numbers to the hottest, coldest, and highest points on the globe. Taking us from the Himalaya to Antarctica and beyond, <i>Higher and Colder</i> presents the first history of extreme physiology, the study of the human body at its physical limits. Each chapter explores a seminal question in the history of science, while also showing how the apparently exotic locations and experiments contributed to broader political and social shifts in twentieth-century scientific thinking.<br/>  <br/> Unlike most books on modern biomedicine, <i>Higher and Colder</i> focuses on fieldwork, expeditions, and exploration, and in doing so provides a welcome alternative to laboratory-dominated accounts of the history of modern life sciences. Though centered on male-dominated practices—science and exploration—it recovers the stories of women’s contributions that were sometimes accidentally, and sometimes deliberately, erased. Engaging and provocative, this book is a history of the scientists and physiologists who face challenges that are physically demanding, frequently dangerous, and sometimes fatal, in the interest of advancing modern science and pushing the boundaries of human ability.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vanessa Heggie
      </h2>
      
      <p class="authorDescription body article"><B>Vanessa Heggie</B> is a lecturer in the history of medicine and science at the Institute of Applied Health Research at the University of Birmingham. She is the author of <I>A History of British Sports Medicine</I> and was coauthor of the <I>Guardian</I> blog <I>The H-Word</I> from 2012 to 2017.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d0cee1e